import Config from "../../_config/index";
import AxiosFetcher from "./AxiosFetcher";
import StorageFactory from "../Storage/factory";

const config = new Config();

const authURL = config.get("AUTH_HOST");

export default class FetcherFactory {
  public static readonly httpFetcher = new AxiosFetcher(
    config,
    authURL,
    StorageFactory.encrypterLocalStorage()
  );
}
